import { useEffect, useRef, useState } from 'react';
import { countries, countryStorageKey, fallbackCountry, timezoneCountries } from '../data/countries';
import { lookupVisitorLocation, visitorTimeZone } from '../utils/visitorLocation';

function initialCountry(): { iso: string; saved: boolean } {
  try {
    const saved = window.localStorage.getItem(countryStorageKey);
    if (saved && countries.some((c) => c.iso === saved)) return { iso: saved, saved: true };
  } catch {
    // storage unavailable
  }
  return { iso: timezoneCountries[visitorTimeZone()] ?? fallbackCountry, saved: false };
}

// The visitor's country — remembered once chosen, otherwise taken from where they browse
export function useVisitorCountry(): [string, (iso: string) => void] {
  const [{ iso, saved }] = useState(initialCountry);
  const [country, setCountry] = useState(iso);
  const chosen = useRef(saved);

  useEffect(() => {
    if (chosen.current) return;
    let active = true;
    lookupVisitorLocation().then(({ countryCode }) => {
      if (active && countryCode && !chosen.current && countries.some((c) => c.iso === countryCode)) {
        setCountry(countryCode);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  const choose = (next: string) => {
    chosen.current = true;
    setCountry(next);
    try {
      window.localStorage.setItem(countryStorageKey, next);
    } catch {
      // storage unavailable
    }
  };

  return [country, choose];
}
